function Contact() {
    return (
        <section className="relative py-20 bg-gradient-to-br from-slate-900 to-slate-800">
            <div className="max-w-6xl mx-auto px-4">

                {/* OUTER CARD */}
                <div className="bg-slate-900 rounded-3xl shadow-2xl overflow-hidden border border-slate-700">

                    {/* HEADER */}
                    <div className="text-center p-10 bg-gradient-to-r from-blue-700 to-indigo-700 text-white">
                        <h1 className="text-3xl md:text-4xl font-bold mb-3">
                            Contact Gavli Hospital
                        </h1>
                        <p className="max-w-2xl mx-auto text-sm md:text-base text-slate-100">
                            We are available 24×7 for emergency care, OPD services, and medical support.
                        </p>
                    </div>

                    {/* CONTENT */}
                    <div className="p-6 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-10">

                        {/* LEFT : INFO BOXES */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

                            {/* ADDRESS */}
                            <div className="bg-slate-800 rounded-2xl p-6 shadow
                                            border border-blue-500/30
                                            hover:-translate-y-1 hover:shadow-xl
                                            transition-all duration-300">
                                <h3 className="font-semibold mb-2 text-blue-400">
                                    📍 Address
                                </h3>
                                <p className="text-sm text-slate-200 leading-relaxed">
                                    Ward No. 7, Near Bhopal–Biaora Highway,<br />
                                    Kurawar, District Rajgarh,<br />
                                    Madhya Pradesh – 465667
                                </p>

                                <a
                                    href="https://www.google.com/maps/place/GAVLI+HOSPITAL"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-1 mt-4
                                               text-sm font-medium text-blue-400
                                               hover:text-blue-300 transition group"
                                >
                                    🧭 Get Directions
                                    <span className="group-hover:translate-x-1 transition-transform">→</span>
                                </a>
                            </div>

                            {/* EMERGENCY */}
                            <div className="bg-slate-800 rounded-2xl p-6 shadow
                                            border border-red-500/30
                                            hover:-translate-y-1 hover:shadow-xl
                                            transition-all duration-300">
                                <h3 className="font-semibold mb-2 text-red-400">
                                    🚑 Emergency (24×7)
                                </h3>

                                <a href="tel:+919755833739"
                                    className="block text-sm text-slate-200 hover:text-red-300 transition group">
                                    +91 97558 33739 <span className="group-hover:translate-x-1 inline-block">→</span>
                                </a>

                                <a href="tel:+919669891909"
                                    className="block text-sm text-slate-200 hover:text-red-300 transition group">
                                    +91 96698 91909 <span className="group-hover:translate-x-1 inline-block">→</span>
                                </a>
                            </div>

                            {/* OPD */}
                            <div className="bg-slate-800 rounded-2xl p-6 shadow
                                            border border-green-500/30
                                            hover:-translate-y-1 hover:shadow-xl
                                            transition-all duration-300">
                                <h3 className="font-semibold mb-2 text-green-400">
                                    🩺 OPD Contact
                                </h3>
                                <a href="tel:+919685851615"
                                    className="text-sm text-slate-200 hover:text-green-300 transition group">
                                    +91 96858 51615 <span className="group-hover:translate-x-1 inline-block">→</span>
                                </a>
                            </div>

                            {/* EMAIL */}
                            <div className="bg-slate-800 rounded-2xl p-6 shadow
                                            border border-purple-500/30
                                            hover:-translate-y-1 hover:shadow-xl
                                            transition-all duration-300">
                                <h3 className="font-semibold mb-2 text-purple-400">
                                    📧 Email
                                </h3>
                                <a
                                    href="mailto:gavlihospital@gmail.com"
                                    className="text-sm text-slate-200 break-all hover:text-purple-300 transition group"
                                >
                                    gavlihospital@gmail.com <span className="group-hover:translate-x-1 inline-block">→</span>
                                </a>
                            </div>

                            {/* HOURS */}
                            <div className="bg-slate-800 rounded-2xl p-6 shadow
                                            border border-blue-400/30 sm:col-span-2
                                            hover:-translate-y-1 hover:shadow-xl
                                            transition-all duration-300">
                                <h3 className="font-semibold mb-2 text-blue-400">
                                    ⏰ Working Hours
                                </h3>
                                <p className="text-sm text-slate-200">
                                    Open 24 Hours • 7 Days a Week
                                </p>
                            </div>
                        </div>

                        {/* RIGHT : GOOGLE MAP */}
                        <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-700">
                            <iframe
                                title="Gavli Hospital Location"
                                src="https://www.google.com/maps?q=GAVLI+HOSPITAL+Kurawar&output=embed"
                                className="w-full h-[350px] lg:h-full border-0"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                allowFullScreen
                            />
                        </div>

                    </div>
                </div>
            </div>

        </section>
    );
}

export default Contact;
